import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Navbar />

      <main className="flex-1 py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading font-extrabold text-4xl text-slate-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-slate max-w-none">
            <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
            
            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing or using JobMatch, you agree to be bound by these Terms of Service. 
              If you do not agree to these terms, please do not use our service.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">2. Description of Service</h2>
            <p className="text-slate-600 mb-4">
              JobMatch provides AI-powered resume analysis to help users optimize their resumes 
              for specific job descriptions. The service includes match scoring, skills gap analysis, 
              and improvement suggestions.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">3. User Accounts</h2>
            <p className="text-slate-600 mb-4">
              You are responsible for maintaining the confidentiality of your account credentials 
              and for all activities that occur under your account. You must provide accurate 
              information when creating an account.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">4. Subscription and Billing</h2>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Subscriptions are billed monthly</li>
              <li>You may cancel your subscription at any time</li>
              <li>Cancellation takes effect at the end of the current billing period</li>
              <li>Refunds are provided at our discretion</li>
            </ul>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">5. Usage Limits</h2>
            <p className="text-slate-600 mb-4">
              Each plan has specific usage limits for analyses and exports. Limits reset monthly. 
              Exceeding limits requires upgrading to a higher tier plan.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">6. Acceptable Use</h2>
            <p className="text-slate-600 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Use the service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Share your account with others</li>
              <li>Abuse or circumvent usage limits</li>
            </ul>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">7. Disclaimer</h2>
            <p className="text-slate-600 mb-4">
              JobMatch provides resume analysis as a tool to assist your job search. We do not 
              guarantee job placement or interview success. Our analysis is AI-generated and 
              should be used as guidance, not as definitive career advice.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">8. Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              To the maximum extent permitted by law, JobMatch shall not be liable for any 
              indirect, incidental, or consequential damages arising from your use of the service.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">9. Changes to Terms</h2>
            <p className="text-slate-600 mb-4">
              We may update these terms from time to time. Continued use of the service after 
              changes constitutes acceptance of the new terms.
            </p>

            <h2 className="font-heading font-bold text-xl text-slate-900 mt-8 mb-4">10. Contact</h2>
            <p className="text-slate-600 mb-4">
              For questions about these Terms, contact us at{' '}
              <a href="mailto:legal@jobmatch.app" className="text-slate-900 underline">legal@jobmatch.app</a>
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
